import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DashboardClaimsComponent } from './dashboard-claims.component';
import { T2TemplateBasicComponent } from 'app/trip2-theme/components/t2-template-basic/t2-template-basic.component';

const routes: Routes = [{
  path: 'pages', component: T2TemplateBasicComponent,
  children: [
    { path: 'claims/summary',
      component: DashboardClaimsComponent,
      data: {
        title: 'Claims Summary'
      }
    }
  ]
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class DashboardClaimsRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/pages/dashboard-claims/dashboard-claims-routing.module.ts